(function() {
    'use strict';
    /*
     * Copyright (c) 2014-15 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .directive('ihhValidIf', ihhValidIf);

    function ihhValidIf() {
        return {
            require: 'ngModel',
            multiElement: true,
            link: function($scope, $element, $attrs, ngModel) {

                var validate = function(value) {
                    if ($attrs.ihhValidIf !== null && $attrs.ihhValidIf.length > 0) {
                        var valid = $attrs.ihhValidIf === 'true';
                        ngModel.$setValidity('validIf', valid);
                    }
                    return value;
                };

                ngModel.$parsers.unshift(validate);
                ngModel.$formatters.push(validate);

                $attrs.$observe('ihhValidIf', function( /*exp*/ ) {
                    // Whenever the comparison model changes we'll re-validate
                    return validate(ngModel.$viewValue);
                });
            }
        };
    }
})();